import React, {useState} from 'react';
import { StyleSheet, Text, TouchableOpacity, View, Linking, Image } from 'react-native';

export default function Market ({market}) {
    const [active, setActive] = useState(false);

    const switchActive = () => {
        setActive(!active)
    }

    const goMap = () => {
        Linking.openURL('geo:' + market.map);
    }

    const goGoogle = () => {
        Linking.openURL('https://maps.google.com/?q=' + market.map);
    }

    const goVideo = () => {
        Linking.openURL(market.video.link);
    }

    return (
    <TouchableOpacity onPress={switchActive}>
        <View style={[market.past ? styles.past : (market.future ? styles.future : styles.today), active ? styles.active : '']}>   
            <View style={[styles.row, styles.far]}>
                <View>
                    <Text style={styles.point}>{market.point}</Text>
                    {
                        market.permanent ? 
                        <Text style={styles.date}>Работает каждый день</Text>
                        :
                        <Text style={styles.date}>{market.today ? '' : ( (market.future ? 'через ' : '') + market.nextDate.fromNow('day') + (market.past ? ' назад' : '') + ', ')}{market.nextDateText}</Text>
                    }
                </View>
                { !active && 
                    <View style={[styles.row]}>
                        {
                            !!market.video && 
                                <Image 
                                    style={styles.smallIcon}
                                    source={require('../assets/youtube.png')}
                                />
                        }
                        {
                            !!market.map &&
                                <Image 
                                    style={styles.smallIcon}
                                    source={require('../assets/map.png')}
                                />
                        }
                    </View>
                }

            </View>
            {
                active && !!market.description &&
                    <View><Text>{market.description}</Text></View>
                    
            }
            { active && 
                    <View style={styles.icons}>
                        {
                            !!market.map &&
                                <TouchableOpacity style={styles.mapTouch} onPress={goMap}>
                                    <View>
                                        <Image 
                                            style={styles.map}
                                            source={require('../assets/map.png')}
                                        />
                                    </View>
                                </TouchableOpacity>
                        }                     
                        {
                        !!market.map &&
                            <TouchableOpacity style={styles.mapTouch} onPress={goGoogle}>
                                <View>
                                    <Image 
                                        style={styles.map}
                                        source={require('../assets/google-maps.png')}
                                    />
                                </View>
                            </TouchableOpacity>
                        }
                        {
                            !!market.video &&
                                <TouchableOpacity style={styles.mapTouch} onPress={goVideo}>
                                    <View>
                                        <Image 
                                            style={styles.map}
                                            source={require('../assets/youtube.png')}
                                        />
                                    </View>
                                </TouchableOpacity>
                        }
                    </View>
                }  
        </View> 
    </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    row: {
        display: 'flex',
        flexDirection: 'row'
    },
    far: {
        justifyContent: 'space-between'
    },
    icons: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'flex-start'
    },
    future: {
        backgroundColor: "#b6bad6",
        margin: 5,
        padding: 10,
        borderRadius: 10
    },
    past: {
        backgroundColor: "#988ca3",
        margin: 5,
        padding: 10,
        borderRadius: 10
    },
    today: {
        backgroundColor: "#cccc77",
        margin: 5,
        padding: 10,
        borderRadius: 10
    },
    point: {
        color: "#111133",
        fontSize: 25
    },
    date: {
        color: "#555577",
    },
    active: {
        borderColor: "#ffffff",
        borderWidth: 1,
        margin: 5,
        borderRadius: 15
    },
    mapTouch: {
        width: 90,
        height: 70,
        borderColor: 'white',
        borderWidth: 0,
        margin: 1
    },
    map: {
        width: 50,
        height: 50,
        resizeMode: 'stretch',
        margin: 10
    },
    smallIcon: {
        width: 16,
        height: 16,
        resizeMode: 'stretch',
        margin: 5
    },
    border: {
        borderColor: 'white',
        borderWidth: 1,
        margin: 1
    }
})
